import { Trans } from '@lingui/macro'
import Link from 'next/link'
import { FC } from 'react'

import { toQAUrl } from '../../../utils/slug'
import { GreenWhatsapp } from '../../icons'
import styles from './SimilarQuestion.module.css'

interface Props {
  answerText: string
  id: string
  questionText: string
  slug: string
}

const SimilarQuestion: FC<Props> = props => {
  const slug = props.slug
  const qUrl = toQAUrl(slug, props.id)

  const answerLink = `${process.env.NEXT_PUBLIC_DOMAIN}${qUrl}`
  const whatsappText =
    `*Question Text*-${props.questionText}\n` +
    `*Answer Text*- ${props.answerText}\n\n` +
    `*Read full answer: ${answerLink}*\n\n` +
    `*I’m using Healofy: India’s largest women app :dancer: to get FREE answers from doctors :female-scientist: & experts for all questions about women & child health, career advice, pregnancy, beauty & weight loss tips:grinning:*\n\n` +
    `*Ask your question NOW for FREE: ${answerLink}*`

  const whatsappLink = `https://wa.me?text=${encodeURIComponent(whatsappText)}`

  return (
    <div className={styles.wrapper}>
      <div className={styles.question}>
        <div className={styles.questionHeader}>
          <h4>
            <Link href={qUrl}>
              <a className={styles.link}>{props.questionText}</a>
            </Link>
          </h4>
        </div>
      </div>
      <div className={styles.answer}>
        <strong>
          <Trans>Answer</Trans>
        </strong>
        <div>{props.answerText}</div>
      </div>
      <div className={styles.shareWrapper}>
        <a className={styles.shareLink} href={whatsappLink}>
          <strong>
            <Trans>Share with friends who have faced this problem</Trans>
          </strong>
          <span className={styles.shareIconWrapper}>
            <GreenWhatsapp />
          </span>
        </a>
      </div>
    </div>
  )
}

export default SimilarQuestion
